var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"block"},[_c('p',{staticClass:"has-text-centered"},[_vm._v("Rivet Education | 2025")])])])
}]

export { render, staticRenderFns }